module.exports = "/_next/static/images/titan-a732dc0bc8375a5515ac82ada998a896.png";